import ActionTypes from 'app/push/ActionTypes';
import routes from 'app/push/routes';

export default {
  routes,
  actionTypes: ActionTypes,
};
